export default "__VITE_ASSET__n5C2QbOF__"